import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "disconnected", // 'connected', 'connecting', 'error', 'disconnected'
};

const socketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setSocketStatus: (state, action) => {
      state.status = action.payload;
    },
  },
});

// Actions
export const { setSocketStatus } = socketSlice.actions;

export const selectStatus = (state) => state.socket.status;

export const socketReducer = socketSlice.reducer;
